module.exports = __webpack_public_path__ + "img/logo-mo-29.197f39f8.svg";